<script setup lang="ts">
import type { TestResult } from '~/models/Assignment'
import { computed } from 'vue'
import AuTaskProgress from '~/components/ui/AuTaskProgress.vue'

const props = defineProps<{
  testResult: TestResult
}>()

const shownValues = computed((): { [key: string]: { color: string, score: number } } => {
  const values: { [key: string]: { color: string, score: number } } = {}
  const { correct = 0, wrong = 0, unanswered = 0 } = props.testResult
  const result = { correct, wrong, unanswered }

  for (const [key, value] of Object.entries(result)) {
    if (value > 0) {
      values[key] = {
        color: key === 'correct' ? 'var(--color-green-30)' : key === 'wrong' ? 'var(--color-coral-30)' : 'var(--color-gray-20)',
        score: value
      }
    }
  }

  return values
})

const progressMax = computed((): number => {
  const { correct = 0, wrong = 0, unanswered = 0 } = props.testResult
  return Object.values({ correct, wrong, unanswered }).reduce((acc, value) => acc + value, 0)
})

const progressValues = computed((): number[] => {
  return Object.entries(shownValues.value).map(([key, value]) => {
    return value.score
  })
})

const progressColors = computed((): string[] => {
  return Object.entries(shownValues.value).map(([key, value]) => {
    return value.color
  })
})
</script>

<template>
  <div class="flex content-center">
    <AuTaskProgress
      class="self-center"
      :max="progressMax"
      :values="progressValues"
      :colors="progressColors"
    />
  </div>
</template>
